import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

const ExpiresInKey = 'Admin-Expires-In'

export function getToken() {
  if (Cookies.get(TokenKey)) {
    return Cookies.get(TokenKey)
  } else {
    if (window.localStorage) {
      return window.localStorage.getItem(TokenKey)
    }
    return Cookies.get(TokenKey)
  }
}

const options = {
  secure: true,
  sameSite: 'none',
};

export function setToken(token) {
  if (window.localStorage) {
    window.localStorage.setItem(TokenKey, token)
  }
  return Cookies.set(TokenKey, token, options)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}
